import { useMutation } from '@tanstack/react-query';

const submitData = async ({
  selectedImage,
  data,
}: {
  selectedImage: File | undefined;
  data: string;
}) => {
  try {
    const response = await fetch(data, {
      method: 'PUT',
      headers: { 'x-ms-blob-type': 'BlockBlob' },
      body: selectedImage,
    });
    return response;
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useUploadBlob = () => {
  return useMutation({
    mutationFn: submitData,
  });
};
